const favorites = []

export default favorites